import React from "react";
import { useTranslation } from "react-i18next";
import data from "./preloaded/setByAdmin.json";
import { useParams } from "react-router-dom";

export const AccountSetByAdmin = () => {
  const { t } = useTranslation();
  let { lang } = useParams();

  return (
    <div className="bg-white shadow-lg rounded-lg my-10 p-4">
      <h2 className="text-xl font-bold text-gray-800 my-4 text-center">{t('user_info.personal_data_set_by_admin')}</h2>
      <div className="text-center">
        {data.map((id) => (
          <a key={id} className="hover:bg-gray-400 mr-1 text-xs break-all" href={`/${lang}/search/${id}`}>{id}</a>
        ))}
      </div>
    </div>
  );
};
